<script lang="ts" setup>
const { createEvent } = useAnalytics()

onMounted(() => {
  createEvent({ name: '[Navigation] Visit Pricing' })
})
</script>

<template>
  <div class="relative flex flex-col items-center">
    <UContainer class="-mt-[calc(var(--header-height)+1.25rem)] flex w-full items-center justify-center pb-24 pt-36">
      <SectionPricing is-main-section />
    </UContainer>

    <!-- <UContainer class="relative w-full py-24">
      <LayoutBackground
        class="inset-0 max-h-[1024px]"
        image="mountain"
        section
      />

      <SectionSubscriptionFeatures />
    </UContainer> -->

    <UContainer class="relative w-full py-24">
      <LayoutBackground
        class="inset-0 max-h-[768px]"
        image="watch"
        section
      />

      <SectionFaq />
    </UContainer>

    <HomeSection>
      <SectionSupport />

      <LayoutBackground
        image="map"
        reverse
      />
    </HomeSection>
  </div>
</template>
